import { FaceClient, FaceModels ,  } from "@azure/cognitiveservices-face";
import { CognitiveServicesCredentials } from "@azure/ms-rest-azure-js";

export default class FaceUtil{
    faceKey:string = "c055bb3942c8466a8c65fd1c9a89a9c4";
    faceEndPoint:string = "https://southeastasia.api.cognitive.microsoft.com/";
    cognitiveServiceCredentials:any = new CognitiveServicesCredentials(this.faceKey);
    client:FaceClient;
    options: FaceModels.FaceDetectWithUrlOptionalParams = {
        returnFaceLandmarks: true,
        returnFaceId:true,
        detectionModel:'detection_01',
        returnFaceAttributes:[
            "headPose"
        ]
    };
    user:any;

    /**
     *
     */
    constructor() {
        this.client = new FaceClient(this.cognitiveServiceCredentials, this.faceEndPoint);
        
    }
    public setUser(user:any){
        this.user = user;
        //console.log({"Face Util Set User ": this.user});
    }

    public async DetectFace(url:string):Promise<(FaceModels.FaceDetectWithUrlResponse|any)> {
        try {
            //console.log(url);   
            let results:(FaceModels.FaceDetectWithUrlResponse);
            results = await this.client.face
            .detectWithUrl(url, this.options);
            return results; 
            
        } catch (error) {
            //console.log("An error occurred:");
            // console.error(error);
            return error;
        }
        
    }

    public async GetPerson(){
        let results:any=null;
        
        if(this.user.personId !== undefined)
        results = await (await this.client.personGroupPerson.get(this.user.id,this.user.personId));
        return results; 
    }
    
    public async AddPersonFace(url:string){
        let results:any;
        //console.log({"this.user.id" : this.user.id , "this.user.personId":this.user.personId,"url":url });
        
        results = await this.client.personGroupPerson.addFaceFromUrl(this.user.id,this.user.personId,url);//Using user.id as group name
        
        return results; 
    }
    public async AddPersonFaceBlob(image: any){
        let results:any;
        
        results = await (await this.client.personGroupPerson.addFaceFromStream(this.user.id,this.user.personId,image));//Using user.id as group name
        this.user.personId = results;
        return results; 
    }
    public async AddPerson():Promise<FaceModels.PersonGroupPersonCreateResponse>{
        
        
        try {
            let results:FaceModels.PersonGroupPersonCreateResponse;
            results = await (await this.client.personGroupPerson.create(this.user.id,{name:this.user.id}));//user id as group name
            return results; 

        } catch (error) {
            return error; 
        }
        
    }
    
    public async AddGroup():Promise<any>{

        try {
            
            let results:any;
            results = await (await this.client.personGroup.create(this.user.id, this.user.id));
            return results; 
            
        } catch (error) {
            if(error.statusCode === 409){
                let results:any;
                results = await (await this.client.personGroup.get(this.user.id));
                return results;
            }
            else{
                throw error;
            }
            
        }
    }

    
    public async Train():Promise<any>{
        let results:any;
        
        results = await (await this.client.personGroup.train(this.user.id));

        return results; 
    }

    /*
    public async AddFace(url:string):Promise<FaceModels.FaceListAddFaceFromUrlResponse> {
        let results:FaceModels.FaceListAddFaceFromUrlResponse;
        results = await this.client.personGroupPerson.create.faceList.addFaceFromUrl("testingusersgroup",url);
         

        return results; 
    }
    */

    public async VerifyFace( personId:any,faceId:any):Promise<{isIdentical:boolean,confidence:number }> {
        let result: {isIdentical:boolean,confidence:number } ={isIdentical:false,confidence:0} ;

        let options2:FaceModels.FaceVerifyFaceToPersonOptionalParams = {
            personGroupId:this.user.id //user id as group 
        };

        await this.client.face
        .verifyFaceToPerson(faceId,personId,options2)
        .then((_result:FaceModels.FaceVerifyFaceToPersonResponse) => {
            // console.log("Face detection result is: ");
            // console.log(_result);
            result={
                isIdentical: _result.isIdentical , confidence: _result.confidence
            }
        })
        .catch((err:any) => {
            //console.log("An error occurred:");
            console.error(err);
        });

        return result;
         
    }
}



